import { render, staticRenderFns } from "./Block5.vue?vue&type=template&id=4bf9b6b8&scoped=true"
import script from "./Block5.vue?vue&type=script&lang=js"
export * from "./Block5.vue?vue&type=script&lang=js"
import style0 from "./Block5.vue?vue&type=style&index=0&id=4bf9b6b8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf9b6b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bf9b6b8')) {
      api.createRecord('4bf9b6b8', component.options)
    } else {
      api.reload('4bf9b6b8', component.options)
    }
    module.hot.accept("./Block5.vue?vue&type=template&id=4bf9b6b8&scoped=true", function () {
      api.rerender('4bf9b6b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/home/Block5.vue"
export default component.exports